import {statePrograms, StateProgramsState} from './statePrograms';
import {combineReducers} from 'redux';
import {stateAssignments, StateAssignmentsState} from './stateAssignments';
import {expenseLiabilities, ExpenseLiabilityState} from './expenseLiabilities';
import {chatbot, ChatbotState} from './chatbot';

export interface SocialSupportState {
  statePrograms: StateProgramsState;
  stateAssignments: StateAssignmentsState;
  expenseLiabilities: ExpenseLiabilityState;
  chatbot: ChatbotState;
}

export const socialSupport = combineReducers({
  statePrograms,
  stateAssignments,
  expenseLiabilities,
  chatbot,
});
